var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-overlay music-content", class: _vm.position },
    [
      _c("audio", {
        ref: `music-preview`,
        on: { canplaythrough: (e) => (e.target.volume = "0.5") },
      }),
      _vm.musicSelected
        ? _c("div", { staticClass: "steep1" }, [
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                { staticClass: "list-item hide-scrollbar" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "item",
                      staticStyle: { "margin-bottom": "0px" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "img",
                          class: {
                            play:
                              (_vm.musicSelected.track &&
                                _vm.urlMusicPlaying ==
                                  _vm.musicSelected.track
                                    .progressive_download_url) ||
                              (_vm.musicSelected.original_sound &&
                                _vm.urlMusicPlaying ==
                                  _vm.musicSelected.original_sound
                                    .progressive_download_url),
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.toggleMusic(_vm.musicSelected)
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.musicSelected.track
                                ? _vm.musicSelected.track
                                    .cover_artwork_thumbnail_uri
                                : _vm.musicSelected.original_sound.ig_artist
                                    .profile_pic_url,
                              alt: "",
                            },
                          }),
                        ]
                      ),
                      _c("div", { staticClass: "info" }, [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.musicSelected.track
                                ? _vm.musicSelected.track.title
                                : _vm.musicSelected.original_sound
                                    .original_audio_title
                            )
                          ),
                        ]),
                        _c("p", { staticClass: "author" }, [
                          _vm._v(
                            _vm._s(
                              _vm.musicSelected.track
                                ? _vm.musicSelected.track.display_artist
                                : _vm.musicSelected.original_sound.ig_artist
                                    .full_name
                            )
                          ),
                        ]),
                      ]),
                      _c("i", {
                        staticClass: "fa-regular fa-xmark",
                        on: { click: _vm.removeMusic },
                      }),
                    ]
                  ),
                  [
                    _c("CursorMusic", {
                      attrs: {
                        music: _vm.musicSelected,
                        defaultRangeDuration: _vm.models.duration.toString(),
                        defaultStart: _vm.models.start,
                        durationLock: _vm.durationLock,
                      },
                      on: {
                        rangeDurationChange: _vm.rangeDurationChange,
                        startChange: _vm.startChange,
                      },
                    }),
                    !_vm.isProd
                      ? _c("div", { staticClass: "balance" }, [
                          _c("h4", [
                            _vm._v(
                              _vm._s(_vm.$t("dash.post-creator.music.balance"))
                            ),
                          ]),
                          _c("div", { staticClass: "inputRange" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.balance,
                                  expression: "balance",
                                },
                              ],
                              attrs: {
                                type: "range",
                                min: "-1",
                                max: "1",
                                step: "0.01",
                              },
                              domProps: { value: _vm.balance },
                              on: {
                                __r: function ($event) {
                                  _vm.balance = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "labels" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("dash.post-creator.music.post-sound")
                                )
                              ),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("dash.post-creator.music.music-sound")
                                )
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                ],
                2
              ),
            ]),
          ])
        : _c("div", { staticClass: "steep2" }, [
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "input" }, [
                _c("i", { staticClass: "fa-regular fa-magnifying-glass" }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.textSearch,
                      expression: "textSearch",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "dash.post-creator.overlay.search-music"
                    ),
                  },
                  domProps: { value: _vm.textSearch },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.sendSearchMusic.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.textSearch = $event.target.value
                    },
                  },
                }),
              ]),
              !_vm.textSearch
                ? _c(
                    "div",
                    { staticClass: "navigation" },
                    _vm._l(Object.entries(_vm.feeds), function ([key, feed]) {
                      return _c(
                        "div",
                        {
                          staticClass: "item-nav",
                          class: { active: _vm.selectedFeed === key },
                          on: {
                            click: function ($event) {
                              return _vm.selectFeed(key)
                            },
                          },
                        },
                        [_vm._v(_vm._s(feed.name))]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "list-item hide-scrollbar" },
                [
                  _vm.stateLoader
                    ? _c("span", { staticClass: "loader" })
                    : _vm.textSearch && _vm.listMusicsAvailable.length === 0
                    ? _c("p", { staticClass: "no-result" }, [
                        _vm._v(
                          _vm._s(_vm.$t("dash.post-creator.overlay.no-music"))
                        ),
                      ])
                    : _vm._l(
                        _vm.listMusicsAvailable.length
                          ? _vm.listMusicsAvailable
                          : _vm.dataInstagramDefault.musics[_vm.selectedFeed],
                        function (music, index) {
                          return _c(
                            "div",
                            {
                              key: `music${index}`,
                              staticClass: "item",
                              on: {
                                click: function ($event) {
                                  return _vm.selectMusic(music)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "img",
                                  class: {
                                    play:
                                      (music.track &&
                                        _vm.urlMusicPlaying ==
                                          music.track
                                            .progressive_download_url) ||
                                      (music.original_sound &&
                                        _vm.urlMusicPlaying ==
                                          music.original_sound
                                            .progressive_download_url),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.toggleMusic(music)
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: music.track
                                        ? music.track
                                            .cover_artwork_thumbnail_uri
                                        : music.original_sound.ig_artist
                                            .profile_pic_url,
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                              _c("div", { staticClass: "info" }, [
                                _c("p", { staticClass: "name" }, [
                                  _vm._v(
                                    _vm._s(
                                      music.track
                                        ? music.track.title
                                        : music.original_sound
                                            .original_audio_title
                                    )
                                  ),
                                ]),
                                _c("p", { staticClass: "author" }, [
                                  _vm._v(
                                    _vm._s(
                                      music.track
                                        ? music.track.display_artist
                                        : music.original_sound.ig_artist
                                            .full_name
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        }
                      ),
                ],
                2
              ),
            ]),
          ]),
      _c("div", { staticClass: "btn-secondary", on: { click: _vm.close } }, [
        _vm._v(_vm._s(_vm.$t("dash.button.close"))),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }